(function () {
  const formLoadedAt = Date.now(); // Track form load time (anti-bot)

  // Debounce helper
  function debounce(fn, delay = 400) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn(...args), delay);
    };
  }

  function validateEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  // API call with timeout
  async function sendSignup(data) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 5000);

    try {
      const response = await fetch('https://extra.affordablegolf.co.uk/newsletter/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data),
        signal: controller.signal
      });

      clearTimeout(timeout);

      if (!response.ok) {
        let errorMessage = 'Request failed';

        try {
          const errorData = await response.json();
          errorMessage = errorData.error || errorMessage;
        } catch (e) {}

        throw new Error(errorMessage);
      }

      return await response.json();

    } catch (error) {
      clearTimeout(timeout);

      if (error.name === 'AbortError') {
        throw new Error('Request timeout');
      }

      throw error;
    }
  }

  function initNewsletterCard(card) {
    const form = card.querySelector('form');
    const emailInput = card.querySelector('input[type="email"]');
    const consentInput = card.querySelector('input[type="checkbox"]');
    const honeypotInput = card.querySelector('input[name="company"]');

    const submitBtn = card.querySelector('button[type="submit"]');
    const spinner = card.querySelector('.spinner');
    const btnText = card.querySelector('#btnText');

    const emailError = card.querySelector('#emailError');
    const consentError = card.querySelector('#consentError');
    const serverError = card.querySelector('#serverError');
    const successMessage = card.querySelector('#successMessage');

    if (!form) return;

    if (submitBtn) submitBtn.disabled = false; // Enable button (JS ready)

    function clearErrors() {
      emailError?.classList.add('hidden');
      consentError?.classList.add('hidden');
      serverError?.classList.add('hidden');
    }

    function setLoading(isLoading) {
      if (!submitBtn) return;

      submitBtn.disabled = isLoading;

      spinner?.classList.toggle('hidden', !isLoading);

      if (btnText) {
        btnText.textContent = isLoading ? 'Signing up...' : 'Sign up';
      }
    }

    // Debounced email validation
    const validateEmailLive = debounce(() => {
      const email = emailInput.value.trim();

      if (!email) {
        emailError?.classList.add('hidden');
        return;
      }

      if (!validateEmail(email)) {
        if (emailError) {
          emailError.textContent = 'Invalid email format.';
          emailError.classList.remove('hidden');
        }
      } else {
        emailError?.classList.add('hidden');
      }
    });

    emailInput?.addEventListener('input', validateEmailLive);

    // Submit handler
    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      clearErrors();

      const email = emailInput.value.trim();
      const consent = consentInput.checked;
      const honeypot = honeypotInput?.value.trim();

      let hasError = false;

      // Email validation
      if (!email) {
        emailError.textContent = 'Email is required.';
        emailError.classList.remove('hidden');
        hasError = true;
      } else if (!validateEmail(email)) {
        emailError.textContent = 'Please enter a valid email.';
        emailError.classList.remove('hidden');
        hasError = true;
      }

      // Consent validation
      if (!consent) {
        consentError.textContent = 'You must accept the terms.';
        consentError.classList.remove('hidden');
        hasError = true;
      }

      if (hasError) return;

      if (honeypot) { // Honeypot check (bot detection)
        console.warn('Bot detected (honeypot filled)');
        return;
      }

      if (Date.now() - formLoadedAt < 1500) { // Too fast submission (bot)
        console.warn('Bot detected (submitted too fast)');
        return;
      }

      setLoading(true);

      try {
        const payload = {
          email,
          consent,
          company: honeypot, // honeypot
          timestamp: new Date().toISOString(),
          source: window.location.href
        };

        const response = await sendSignup(payload);

        if (response.status === 'ok') {
          form.classList.add('hidden');
          successMessage?.classList.remove('hidden');
        } else {
          throw new Error('Unexpected response');
        }

      } catch (error) {
        console.error('Newsletter signup error:', error);
        serverError?.classList.remove('hidden');
      } finally {
        setLoading(false);
      }
    });
  }

  // Init all instances
  function initAll() {
    const cards = document.querySelectorAll('.newsletter-card');
    cards.forEach(initNewsletterCard);
  }

  // Defer-safe init
  initAll();
})();
